import React from 'react';

import { MainContent } from 'components/skip-to-main';
import useDelayedRender from 'shared/hooks/use-delayed-render';

import { PlaceholderMenuImageBanner, PlaceholderCategoriesNav } from '../placeholder-content';

// Delay showing the skeleton to avoid a flash when the real content resolves quickly.
const LOADING_STATE_DELAY_MS = 200;

/**
 * Skeleton for the /stores/[cName] homepage shown while the dispensary hasn't loaded yet.
 */
export function HomePageLoadingState(): JSX.Element | null {
  const delayedRender = useDelayedRender(LOADING_STATE_DELAY_MS);

  return delayedRender(() => (
    <MainContent>
      <PlaceholderMenuImageBanner />
      <PlaceholderCategoriesNav />
    </MainContent>
  ));
}
